import { coreDefaultBaseColors } from "@b2bportal/core-themes";

export const coreDefaultUiColors = {
  // Input
  "core-color-input-label": "inherit",
  "core-color-input-value": "inherit",
  "core-color-input-background":
    coreDefaultBaseColors["core-color-surface-interactive"],
  "core-color-input-border": coreDefaultBaseColors["core-color-border"],
  "core-color-input-error": coreDefaultBaseColors["core-color-border-error"],
  "core-color-input-disabled-border":
    coreDefaultBaseColors["core-color-border-disabled"],
  "core-color-input-disabled-background":
    coreDefaultBaseColors["core-color-surface-interactive-disabled"],
  "core-color-input-disabled-text":
    coreDefaultBaseColors["core-color-text-disabled"],
  "core-color-input-disabled-label":
    coreDefaultBaseColors["core-color-text-secondary"],

  // Card
  "core-card-color-border": coreDefaultBaseColors["core-color-border"],
  "core-card-color-surface": coreDefaultBaseColors["core-color-surface-color"],

  // Button
  "core-color-button-background": "#0276B1",
  "core-color-button-text": coreDefaultBaseColors["text-inverted-color"],
  "core-color-button-hover-background": "#0276B1",
  "core-color-button-hover-text": coreDefaultBaseColors["text-inverted-color"],

  //Tooltip
  "core-color__tooltip-surface":
    coreDefaultBaseColors["core-color-surface-color"],
  "core-color__tooltip-text": coreDefaultBaseColors["core-color-text-primary"],

  //Map
  "core-color__map-marker-background": "#fff",
  "core-color__map-marker-text": "var(--text-primary)",
  "core-color__map-marker-hover-text": "#ffffff",
  "core-color__map-marker-hover-background": "var(--primary)",

  //Pill
  "pill-error-fill-color": "var(--error-fill-color)",
};
